// Display filter only. Transport authorization and credential selection stay on the server.
export function packagePolicyPrefixes(instance) {
  if (!instance || instance.policyInheritanceError) return [];
  const entries = Array.isArray(instance.policyCredentials)
    ? instance.policyCredentials.filter(entry => entry && typeof entry.key === "string" && entry.username)
    : [];
  const selectedKey = instance.policyCredentialSource?.key ?? instance.policyTransportKey;
  const relevant = selectedKey != null ? entries.filter(entry => entry.key === selectedKey) : entries;
  return [...new Set(relevant.map(entry => entry.key.trim().replace(/_+$/, "").toUpperCase()).filter(Boolean))];
}

export function matchesPackagePolicy(pkg, prefixes) {
  return prefixes.some(prefix => [pkg.name, pkg.id].some(value =>
    typeof value === "string" && value.toUpperCase().startsWith(prefix)));
}
